/* global NetworkConfig */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Account from 'components/Account';
import { OVERLAY_ACCOUNT } from 'helpers/FilterHelper';
import { isAppViewExcluded, helperGetHomeUrl } from 'helpers/RouteHelper';
import { browserHistory } from 'react-router';

import { getNetworkLogoUrl } from 'helpers/ContentHelper';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    const { openAccount, showAccount } = this.props;

    this.showAccount = showAccount;
    this.openAccount = openAccount;
  }

  closeAccount = () => {
    const { setOverlay } = this.props;
    setOverlay(OVERLAY_ACCOUNT, false);
    browserHistory.push(helperGetHomeUrl());
  };

  render() {
    const {
      params: { resetCode: resetCodeDirect },
      accountEmail,
      autoFocus,
      resetConfirm,
      location,
    } = this.props;
    const resetCodeQuery = _.get(location, 'query.pwrt');
    const resetCode = resetCodeDirect || resetCodeQuery;
    if (!resetCode) {
      this.closeAccount();
      return null;
    }

    const { branding } = NetworkConfig;
    const network = [
      {
        branding,
        logo: getNetworkLogoUrl(branding, 50),
      },
    ];

    return (
      <Account
        accountEmail={accountEmail}
        backgroundClass="withBackground"
        closeAccount={this.closeAccount}
        showAccount={this.showAccount}
        language={window.Language}
        autoFocus={autoFocus}
        openAccount={this.openAccount}
        resetCode={resetCode}
        network={network}
        resetConfirm={resetConfirm}
        initialScreen="resetPassword"
        isAppViewExcluded={isAppViewExcluded}
      />
    );
  }
}

ResetPassword.defaultProps = {
  accountEmail: '',
  autoFocus: false,
  location: null,
};

ResetPassword.propTypes = {
  accountEmail: PropTypes.string,
  autoFocus: PropTypes.bool,
  location: PropTypes.string,
  openAccount: PropTypes.func.isRequired,
  params: PropTypes.shape({}).isRequired,
  resetConfirm: PropTypes.func.isRequired,
  setOverlay: PropTypes.func.isRequired,
  showAccount: PropTypes.bool,
};

const mapStateToProps = ({ app }) => ({
  accountEmail: app?.account?.email,
});

export default connect(mapStateToProps)(ResetPassword);
